export default __webpack_public_path__ + "static/images/OEMI_DK_Sort_2Erplc.svg";